'use client';

import { faCartShopping } from '@fortawesome/pro-light-svg-icons';
import { usePathname } from 'next/navigation';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartDrawer } from '@/app/(main)/_components/cart/cart-drawer.component';
import { IconButton } from '@/components/ui/icon-button/icon-button.component';
import { Sheet, SheetTrigger } from '@/components/ui/sheet';
import { useFeatureFlag } from '@/feature-flags/hooks/use-feature-flag.hook';
import { authStore } from '@/store/auth.store';
import { cartStore, closeCart, setCartOpen } from '@/store/cart/cart.store';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { getCartOrigin } from '@/utils/cart/get-cart-origin.util';

export function HeaderCartButton() {
  const { value: enabled, loading } = useFeatureFlag('newCart');
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const isOpen = useStore(cartStore, (state) => state.isOpen);
  const pathname = usePathname();

  if (loading || !enabled || !isLoggedIn) {
    return null;
  }

  const openSearch = () => {
    closeCart();
    handleOpenSearchModal();
  };

  return (
    <Sheet open={isOpen} onOpenChange={(nextOpen) => setCartOpen(nextOpen, getCartOrigin(pathname))}>
      <SheetTrigger asChild>
        <IconButton
          icon={faCartShopping}
          label="Carrinho"
          data-testid={DataTestIdEnum.CART_HEADER_BUTTON}
        />
      </SheetTrigger>

      <CartDrawer onAddProcedure={closeCart} onSearch={openSearch} />
    </Sheet>
  );
}
